// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"895a46b7","343":"7ac2e3cf","787":"3650da69"}[chunkId] + ".chunk.js";
};